import React, { useState, useCallback } from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { photos } from "../photos";
import Container from 'react-bootstrap/Container'
import projectImage from "../static/img/pastProject_dark.png"
import { getText } from "../Text";

function PastProjects(language) {
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);
    
    const openLightbox = useCallback((event, { photo, index }) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    }, []);
    
    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    return (
        <div>
            <div className="pastProject" style={{backgroundImage: `url(${projectImage})`}}>
                <Container>
                    <div className="pastProject-header">
                        <h1 className="bannerHeader"> {getText(language.language).project_page.header} </h1>
                    </div>
                </Container>
            </div>
            <Container>
                <Gallery photos={photos} onClick={openLightbox} />
                <ModalGateway>
                    {viewerIsOpen ? (
                    <Modal onClose={closeLightbox}>
                        <Carousel
                        currentIndex={currentImage}
                        views={photos.map(x => ({
                            ...x,
                            srcset: x.srcSet,
                            caption: language.language === "US" ? x.title.us : x.title.zh
                        }))}
                        />
                    </Modal>
                    ) : null}
                </ModalGateway>
            </Container>
        </div>
      );
}

export default PastProjects